import { t } from 'i18n';
import React from 'react';
import { Button, styled, LazyImage } from '@teko/ds-desktop';
import { useRouter } from 'next/router';

const Wrapper = styled.div`
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 32px;
`;
const Description = styled.div`
  color: #848788;
  margin-top: 16px;
  margin-bottom: 24px;
`;

export const EmptyCartPanel: React.FunctionComponent = ({ ...props }) => {
  const router = useRouter();
  return (
    <Wrapper {...props}>
      <LazyImage src="https://i.imgur.com/Drj57qu.png" />
      <Description>{t('Giỏ hàng chưa có sản phẩm nào')}</Description>
      <Button
        variant="primary"
        size="m"
        onClick={() => router.push('/')}
        className="buy-now"
      >
        {t('Mua sắm ngay')}
      </Button>
    </Wrapper>
  );
};
